/* eslint-disable
    no-shadow
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';
import _ from 'underscore';
import React from 'react';
import ReactDOM from 'react-dom';

import * as analytics from 'analytics/Analytics';
import ActionZone from 'assembly/ActionZone';
import asm from 'assembly/Asm';
import GibsonSlotView from 'assembly/views/GibsonSlotView';
import GoldenGateSlotView from 'assembly/views/GoldenGateSlotView';
import RestrictionSlotView from 'assembly/views/RestrictionSlotView';
import SpacerSlotView from 'assembly/views/SpacerSlotView';
import SingleFragmentAssemblyTemplate from 'assembly/SingleFragmentAssemblyTemplate';
import * as biojs from 'BioJS';
import * as sequencelib from 'components/Sequence';
import {ANALYTICS_MODULE} from 'constants/AnalyticsConstants';
import * as AssemblyConstants from 'constants/AssemblyConstants';
import FolderDAOCache from 'file-browser/FolderDAOCache';
import FileStates from 'FileStates';
import * as LoadingScreen from 'ui-library/LoadingScreen';
import {getReindexedPosition} from 'molbio/SeqUtil';
import notifications from 'notifications';
import preferences from 'Preferences';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import setTestAttrs from 'test/lib/cypress/setTestAttrs';
import * as modals from 'util/Modals';

import AssemblyFolderModalClass from './AssemblyFolderModal';

const {ASSEMBLY_TYPE} = AssemblyConstants;

class SingleFragmentWizard extends Backbone.View {
  static initClass() {
    this.prototype.template = SingleFragmentAssemblyTemplate;
    this.prototype.className = 'assembly-wizard';
    this.prototype.events = {
      'click .js-add': 'add',
      'click .show-preview': 'activateInfo',
      'click .js-adjust-params': 'adjustParams',
      'click .slot-activator': 'activate',
    };

    this.prototype.slotTypes = _.object([
      [ASSEMBLY_TYPE.DIGEST, RestrictionSlotView],
      [ASSEMBLY_TYPE.GIBSON, GibsonSlotView],
      [ASSEMBLY_TYPE.GOLDEN_GATE, GoldenGateSlotView],
    ]);
  }

  initialize(options) {
    this.listenTo(this.model, 'resize', this.toggle);
    this.slotViews = [];
    this.sequences = FileStates.get();
    this.sequence = options.sequence;
    this.slots = this.model.slots();
    this.listenTo(this.slots, 'remove', this.updateSlots);
    this.listenTo(this.slots, 'add', function () {
      this.updateSlots();
      this.scrollSlotsRight();
    });
    this.listenTo(this.model, 'change:name change:errors change:warnings', this.renderActionZone);
    this.listenTo(this.slots, 'change:active slotChange', this.renderActionZone);
  }

  activate(e) {
    const $li = $(e.currentTarget).closest('li');
    const selected = this.slots.at($li.parent().children('li').index($li));
    if (selected.active()) {
      selected.set({active: false});
    } else {
      this.slots.each((slot) => {
        slot.set({active: slot === selected});
      });
      if (this.model.method() === ASSEMBLY_TYPE.DIGEST) {
        this.$('.show-preview').html('Hide Preview');
        this.$('.info').addClass('active');
      }
    }
    this.toggle();
  }

  activateInfo(e) {
    const $btn = $(e.currentTarget);
    const $info = this.$('.info');
    if ($info.hasClass('active')) {
      $btn.html('Show Preview');
      $info.removeClass('active');
      if (this.model.method() === ASSEMBLY_TYPE.DIGEST) {
        this.slots.each((slot) => slot.set({active: false}));
      }
    } else {
      $btn.html('Hide Preview');
      $info.addClass('active');
    }
    this.toggle();
  }

  add() {
    analytics.track('assembly', 'add_insert', {
      product: ANALYTICS_MODULE.MOLBIO,
      assemblyMethod: this.model.method(),
    });
    const $addButton = this.$('.js-add');
    // Only allow adding 1 slot at a time
    $addButton.prop('disabled', true);
    this.model
      .slots()
      .addSlot({})
      .always(() => {
        $addButton.prop('disabled', false);
      });
  }

  scrollSlotsRight() {
    const $navbar = this.$('.navbar-nav');
    $navbar.scrollLeft($navbar[0].scrollWidth);
  }

  updateSequence(sequence) {
    if (this.sequence != null) {
      this.stopListening(this.sequence._sequence());
    }
    if (this.selection != null) {
      this.stopListening(this.selection);
    }
    if (this.cutsites != null) {
      this.stopListening(this.cutsites);
    }
    this.sequence = sequence;
    for (const slotView of Array.from(this.slotViews)) {
      slotView.updateSequence(this.sequence);
    }
    if (this.sequence != null) {
      this.selection = this.sequence.selection();
      this.listenTo(this.sequence._sequence(), 'change:startIndex', this.renderActionZone);
      this.listenTo(
        this.selection,
        'change:start change:end change:startState change:endState',
        this.renderActionZone
      );
      this.cutsites = this.sequence.get('cutsites');
      // We only listen to know when to re-render but don't actually use use data `@cutsites` because it
      // only contains active enzymes' cutsites.
      this.listenTo(this.cutsites, 'cutsitesChanged', this.renderActionZone);
    } else {
      this.selection = null;
      this.cutsites = null;
    }
    this.renderActionZone();
  }

  // The ActionZone (TM) is the area in the top right with errors/warnings, parameters, create button, etc.
  renderActionZone() {
    let cutsites;
    let selection;
    if (
      (this.selection != null ? this.selection.start() : undefined) != null ||
      (this.selection != null ? this.selection.end() : undefined) != null
    ) {
      selection = {
        start: this.selection.start(),
        end: this.selection.end(),
        cutStart: this.selection.getStartState('cutsite'),
        cutEnd: this.selection.getEndState('cutsite'),
      };
    } else {
      selection = null;
    }
    if (this.sequence == null || this.model.method() !== ASSEMBLY_TYPE.GOLDEN_GATE) {
      cutsites = [];
    } else {
      cutsites = this.sequence._sequence().getCuts(this.model.enzyme().toJSON());
    }
    const component = (
      <ActionZone
        activeSlot={this.slots.findWhere({active: true})}
        assembly={this.model}
        cutsites={cutsites}
        createAssembly={this.create.bind(this)}
        deleteAssembly={this.deleteAssembly.bind(this)}
        errors={this.model.errors()}
        selection={selection}
        sequence={this.sequence}
        updateParameters={this.updateParameters.bind(this)}
        warnings={this.model.warnings()}
      />
    );
    renderToDOM(component, this.$('.action-zone-mount')[0]);
  }

  updateParameters(parameters) {
    this.model.set({parameters});
    preferences.set(this.model.method(), parameters);
    this.renderActionZone();
  }

  deleteAssembly() {
    if (this.model.get('slots').any((slot) => !slot.isEmpty())) {
      const msg = 'Are you sure you want to delete the assembly? It cannot be recovered.';
      modals.confirm('Delete Assembly', msg, 'danger').done(() => this.model.destroy());
    } else {
      this.model.destroy();
    }
  }

  updateSlots() {
    const SlotType = this.slotTypes[this.model.method()];
    for (const view of Array.from(this.slotViews)) {
      view.remove();
    }
    this.slotViews = this.slots.map((slot) => {
      if (slot.isSpacer()) {
        return new SpacerSlotView({model: slot, assembly: this.model});
      } else {
        return new SlotType({model: slot, assembly: this.model});
      }
    });
    if (this.sequence != null) {
      this.updateSequence(this.sequence);
    }
    // eslint-disable-next-line no-restricted-syntax
    this.$('.navbar-nav').html(_.map(this.slotViews, (slot) => slot.render().el));
  }

  toggle() {
    $('#editor')
      .addClass('has-assemblyWizard')
      .toggleClass('has-assemblyWizard-info', this.$('.info').hasClass('active'));
    $(window).trigger('buffersResize');
  }

  trackCreateAssemblyFail(error) {
    analytics.track('assembly', 'create_fail', {
      product: ANALYTICS_MODULE.MOLBIO,
      assemblyMethod: this.model.method(),
      error,
    });
  }

  create() {
    let maxOverlap;
    let minOverlap;
    let tmAnneal;
    let tmDiff;
    let tmWhole;
    if (this.model.method() === ASSEMBLY_TYPE.GIBSON) {
      ({tmAnneal, tmWhole, tmDiff, minOverlap, maxOverlap} = this.model.parameters());
      if (
        Number.isNaN(tmAnneal) ||
        Number.isNaN(tmWhole) ||
        Number.isNaN(tmDiff) ||
        Number.isNaN(minOverlap) ||
        Number.isNaN(maxOverlap)
      ) {
        const message = 'Please enter valid Gibson primer settings.';
        notifications.warn(message);
        this.trackCreateAssemblyFail(message);
        return;
      }
    }

    LoadingScreen.show();
    _.delay(() => {
      let _sequence;
      let fragmentResultModels;
      let fragments;
      let junctions;
      const options = {annotations: true, notcontained: true};

      // What to do if we reach an assembly error.
      const rollbackAssembly = (message) => {
        this.trackCreateAssemblyFail(message);
        LoadingScreen.hide();
        notifications.warn(message);
      };

      const completeAssembly = (_sequence, fragmentResultModels) => {
        _sequence.set({
          name: this.model.name(),
          fragmentResults: new biojs.FragmentResultCollection(fragmentResultModels),
        });

        function createSequence(sequenceFolderId, oligoFolderId) {
          _sequence.set({folder: sequenceFolderId});
          _sequence.get('sequencePrimers').each((primer) => {
            primer.set({folder: oligoFolderId});
          });
          return _sequence.save().then(() => {
            FolderDAOCache.invalidateFolderContents(sequenceFolderId);
            FolderDAOCache.invalidateFolderContents(oligoFolderId);
            return FileStates.get().openFolderItem(_sequence.get('id'));
          });
        }
        if (_sequence.get('sequencePrimers').filter((primer) => !primer.get('skip')).length) {
          LoadingScreen.hide();
          AssemblyFolderModalClass.open({createSequence});
        } else {
          LoadingScreen.hide();
          sequencelib.Sequence.saveAndOpenSequence(_sequence);
        }

        analytics.track('assembly', 'create_success', {
          product: ANALYTICS_MODULE.MOLBIO,
          assemblyMethod: this.model.method(),
        });
        this.model.collection.remove(this.model);
      };

      // TODO(gg) Move these to asm.js.
      if (this.model.method() === ASSEMBLY_TYPE.GIBSON) {
        // eslint-disable-next-line no-restricted-syntax
        fragments = _.map(this.slots.withoutSpacers(), (slot) => {
          let seqFragment;
          const fragment = slot.singleFragment();
          const sequence = fragment.getSequence();
          if (fragment.enzymeIDs() != null) {
            seqFragment = fragment.getSelectedFragmentFromSequence(sequence);
          } else {
            const start = fragment.start();
            const end = fragment.end();
            seqFragment = sequence.get('_sequence').createFromIndices(start, end, options);
          }
          if (fragment.reverse()) {
            seqFragment = seqFragment.cloneReverseComplement();
          }
          seqFragment.set({
            name: sequence.name(),
          });
          return seqFragment;
        });

        _sequence = asm.gibson.designGibson(fragments, this.slots.getSpacers(), {
          tmAnneal,
          tmWhole,
          tmDiff,
          minOverlap,
          maxOverlap,
        });
        if (_sequence == null) {
          rollbackAssembly(
            <div>
              No Gibson primers could be generated. Try <strong>increasing the max TM diff</strong> allowed
              between primer pairs or <strong>lowering the min TM</strong> required of primers.
            </div>
          );
          return;
        }
        junctions = _sequence.get('junctions');
        // eslint-disable-next-line no-restricted-syntax
        fragmentResultModels = _.map(this.slots.withoutSpacers(), (slot, index) => {
          const fragment = slot.singleFragment();
          const [start, end] = Array.from(junctions[index]);

          return new biojs.FragmentResult({
            fragmentID: fragment.id,
            versionID: fragment.getSequence().getActiveVersionId(),
            pairIndex: fragment.enzymeIDs() != null ? undefined : index,
            start,
            end,
            originalBases: fragments[index].bases(),
          });
        });
      } else if (this.model.method() === ASSEMBLY_TYPE.GOLDEN_GATE) {
        let hasStickyEnds;
        [fragments, hasStickyEnds] = Array.from(asm.goldenGate.slotsToFragments(this.slots.withoutSpacers()));
        asm.goldenGate
          .designGoldenGate(
            fragments,
            hasStickyEnds,
            this.slots.getSpacers(),
            _.clone(this.model.parameters())
          )
          .progress((percentComplete) => {
            LoadingScreen.set(`designing... ${Math.round(percentComplete)}%`);
          })
          .done((_sequence) => {
            LoadingScreen.set('loading...');
            junctions = _sequence.get('junctions');
            // eslint-disable-next-line no-restricted-syntax
            fragmentResultModels = _.map(this.slots.withoutSpacers(), (slot, index) => {
              const fragment = slot.singleFragment();
              const [start, end] = Array.from(junctions[index]);

              return new biojs.FragmentResult({
                fragmentID: fragment.id,
                versionID: fragment.getSequence().getActiveVersionId(),
                start,
                end,
                pairIndex: fragment.enzymeIDs() != null ? undefined : index,
                originalBases: fragments[index].bases(),
              });
            });
            completeAssembly(_sequence, fragmentResultModels);
          })
          .fail(rollbackAssembly);
      } else if (this.model.method() === ASSEMBLY_TYPE.DIGEST) {
        let fragment;
        let offset5;
        _sequence = null;
        let digestJunctions = [];
        for (const slot of Array.from(this.slots.withoutSpacers())) {
          fragment = slot.get('thisFragment');
          const endIndex = fragment.length() - Math.abs(fragment.get('offset3'));
          const fragmentFromIndices = fragment.createFromIndices(0, endIndex, options);
          const junction5 = _sequence?.length() ?? 0;
          if (_sequence != null) {
            _sequence = _sequence.concat(fragmentFromIndices);
          } else {
            offset5 = fragment.get('offset5');
            _sequence = fragmentFromIndices;
          }
          const junction3 = _sequence.length();
          digestJunctions.push([junction5, junction3]);
        }

        _sequence.set({circular: true, offset5: 0});

        // Keep same indexing as backbone sequence.
        //
        // To make sure the first base of the assembled sequence was also the first base of the
        // backbone sequence: reindex the assembled sequence so that the first base of the backbone
        // fragment has the same index as it did in the backbone sequence, corrected by the
        // difference in backbone vs. assembled sequence lengths.
        const backboneFragment = this.slots.at(0).singleFragment();
        let reindex = backboneFragment.start();
        if (offset5 < 0) {
          // The fragment starts at the cut but its bases include the sticky end before the cut, so
          // adjust by offset5.
          reindex += offset5;
        }
        reindex += _sequence.length() - backboneFragment.getSequence().length();
        if (0 <= reindex && reindex < _sequence.length()) {
          _sequence.opReindex({current: 0, desired: reindex});
          const reindexPos = _sequence.length() - reindex;
          digestJunctions = digestJunctions.map(([start, end]) => [
            getReindexedPosition(start, reindexPos, _sequence.length()),
            getReindexedPosition(end, reindexPos, _sequence.length()),
          ]);
        }

        // eslint-disable-next-line no-restricted-syntax
        fragmentResultModels = _.map(this.slots.withoutSpacers(), (slot, index) => {
          fragment = slot.singleFragment();
          const sequence = fragment.getSequence();

          return new biojs.FragmentResult({
            start: digestJunctions[index][0],
            end: digestJunctions[index][1],
            fragmentID: fragment.id,
            versionID: fragment.getSequence().getActiveVersionId(),
            originalBases: sequence.get('_sequence').residueSlice(fragment.start(), fragment.end()),
          });
        });
      } else {
        const message = `Unexpected assembly type: ${this.model.method()}`;
        this.trackCreateAssemblyFail(message);
        throw new Error(message);
      }

      if (this.model.method() === ASSEMBLY_TYPE.GOLDEN_GATE) {
        return; // Golden Gate is asynchronous.
      }
      completeAssembly(_sequence, fragmentResultModels);
    }, 100);
  }

  render() {
    this.$el.html(this.template());
    this.$('.info').addClass('active');
    this.$('.show-preview').html('Hide Preview');

    this.$('[data-toggle="tooltip"]').tooltip('destroy');
    setTestAttrs(this.$el, {component: 'SingleFragmentWizard', element: 'root'});

    this.updateSlots();
    this.renderActionZone();
    this.toggle();
    return this;
  }

  remove() {
    ReactDOM.unmountComponentAtNode(this.$('.action-zone-mount')[0]);
    for (const view of Array.from(this.slotViews)) {
      view.remove();
    }
    return super.remove();
  }
}
SingleFragmentWizard.initClass();

export default SingleFragmentWizard;
